import LocalStorageReferral_uuid from '_services/LocalStorage/Referral_uuid';

const REFERRAL_QUERY_PARAM = 'referral_uuid';

const normalizeReferralUuid = (value: string | null): string | null => {
    if (!value) {
        return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    return trimmed;
};

let referralUuid: string | null = normalizeReferralUuid(
    LocalStorageReferral_uuid.get(),
);

if (LocalStorageReferral_uuid.get() && !referralUuid) {
    LocalStorageReferral_uuid.remove();
}

const setUuid = (nextReferralUuid: string | null): void => {
    const normalized = normalizeReferralUuid(nextReferralUuid);
    referralUuid = normalized;

    if (normalized) {
        LocalStorageReferral_uuid.set(normalized);
        return;
    }

    LocalStorageReferral_uuid.remove();
};

const getUuidFromSearch = (search: string): string | null => {
    return normalizeReferralUuid(
        new URLSearchParams(search).get(REFERRAL_QUERY_PARAM),
    );
};

const captureFromSearch = (search: string): string | null => {
    const referralUuidFromSearch = getUuidFromSearch(search);

    if (!referralUuidFromSearch) {
        return null;
    }

    setUuid(referralUuidFromSearch);
    return referralUuidFromSearch;
};

const getUuid = (): string | null => {
    const normalizedInMemoryReferralUuid = normalizeReferralUuid(referralUuid);
    if (normalizedInMemoryReferralUuid) {
        referralUuid = normalizedInMemoryReferralUuid;
        return normalizedInMemoryReferralUuid;
    }

    if (referralUuid !== null) {
        referralUuid = null;
        LocalStorageReferral_uuid.remove();
    }

    const storedReferralUuid = normalizeReferralUuid(
        LocalStorageReferral_uuid.get(),
    );
    if (storedReferralUuid) {
        referralUuid = storedReferralUuid;
    } else {
        LocalStorageReferral_uuid.remove();
    }

    return referralUuid;
};

const isReferred = (): boolean => {
    return !!getUuid();
};

const peekUuid = (): string | null => {
    return referralUuid;
};

const clear = (): void => {
    setUuid(null);
};

const ReferralContextService = {
    captureFromSearch,
    clear,
    getUuid,
    getUuidFromSearch,
    isReferred,
    peekUuid,
    setUuid,
};

export default ReferralContextService;
